<template>
	<article>
		<n-space vertical
			style="flex: 1 1 auto;">
			<n-layout has-sider
				style="flex: 0 0 auto; height: calc(100vh - 80px);">
				<n-layout-sider
					bordered
					style="height: 100%;flex: 0 0 auto"
					collapse-mode="width"
					:collapsed-width="sidebar.collapsed.colwidth"
					:width="sidebar.collapsed.width"
					:collapsed="sidebar.collapsed.status"
					:show-trigger="!sidebar.mobile"
					@collapse="sidebar.collapsed.status = true"
					@expand="sidebar.collapsed.status = false"
				>
					<n-menu
						:collapsed="sidebar.collapsed.status"
						:collapsed-width="sidebar.collapsed.colwidth"
						:collapsed-icon-size="sidebar.collapsed.colwidth - 40"
						:options="sidebar.menu"
						@update:value="handleUpdateSidebar"
					/>
					<n-button round
						class="menu-btn"
						@click="sidebar.collapsed.status = !sidebar.collapsed.status">
						<n-icon style="width: 30px; height: 30px;">
							<Menu style="width: 30px; height: 30px;"/>
						</n-icon>
					</n-button>

				</n-layout-sider>
				<n-layout style="position: relative; height: 100%;">
					<n-scrollbar>
						<section class="content">
							<div class="container">
								<router-view/>
							</div>
						</section>
						<div class="footer">test</div>
					</n-scrollbar>
				</n-layout>
			</n-layout>
		</n-space>
	</article>
</template>

<script setup>
import { Home, People, Balloon, Car, Menu } from "@vicons/ionicons5"
import { h, reactive, onMounted } from "vue"
import { useRouter } from "vue-router"
import { NIcon } from "naive-ui"
const router = useRouter()
const renderIcon = (icon) => {
	return () => h(NIcon, null, { default: () => h(icon) })
}
const sidebar = reactive({
	mobile: false,
	collapsed: {
		status: true,
		width: 240,
		colwidth: 64
	},
	menu: [
		{
			label: "Главная",
			key: "home",
			href: "/",
			icon: renderIcon(Home)
		},
		{
			key: "divider-1",
			type: "divider",

		},
		{
			label: "Скины",
			key: "skins",
			href: "/general/skins",
			icon: renderIcon(People)
		},
		{
			label: "Автомобили",
			key: "cars",
			href: "/general/cars",
			icon: renderIcon(Car)
		},
		{
			label: "Аксессуары",
			key: "accessories",
			href: "/general/accessories",
			icon: renderIcon(Balloon)
		},
	]
})

const handleUpdateSidebar = (key, item) => {
	if (window.innerWidth < 768) {
		sidebar.collapsed.status = true
	}
	router.push(item.href)
}

const updateMobileDesign = (width) => {
	if (width < 768) {
		sidebar.mobile = true
		sidebar.collapsed.width = "100%"
		sidebar.collapsed.colwidth = 0
	} else {
		sidebar.mobile = false
		sidebar.collapsed.width = 240
		sidebar.collapsed.colwidth = 64
	}

}

onMounted(() => {
	document.title = "WIKI BLACK RUSSIA: Главная"
	updateMobileDesign(window.innerWidth)
	window.addEventListener("resize", () => {
		updateMobileDesign(window.innerWidth)
	})
})
</script>

<style lang="scss">
  article {
    position: relative;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;

  }
  .content {
    margin-top: 20px;
    padding-bottom: 30px;
    display: block;
    overflow-x: hidden;
    //white-space: nowrap;
  }
  .menu-btn {
    display: none;
    position: absolute;
    left: 15px;
    bottom: 40px;
    width: 50px;
    height: 50px;
    padding: 0 0;
    background: rgba(0,0,0, 0.4);
    backdrop-filter: blur(10px);
  }
  @media (max-width: 768px) {
    .menu-btn {
      display: flex;
    }
  }
</style>